import React from 'react'
import { Button } from '@shared/components/button'
import { scrollToApplicationForm } from '@shared/components/forms/application/cross'
import CharPieSlice from '@shared/svg/in-shape/charPieSlice.svg'
import GearSix from '@shared/svg/in-shape/gearSix.svg'
import Loan from '@shared/svg/in-shape/loan.svg'
import Prohibit from '@shared/svg/in-shape/prohibit.svg'
import ShieldCheck from '@shared/svg/in-shape/shieldCheck.svg'
import ShoppingCart from '@shared/svg/in-shape/shoppingCart.svg'
import Timer from '@shared/svg/in-shape/timer.svg'

import styles from './style.module.scss'

const offers = [
	['a', 'Пополнение кассовых разрывов', CharPieSlice],
	['b', 'Расширение производства', Loan],
	['c', 'Если отказали в банке', Prohibit],
	['d', '«Перехватиться» до поступления средств', ShieldCheck],
	['e', 'Нужна надёжная кредитная линия', Timer],
	['f', 'Покупка оборудования', GearSix],
	['g', 'Пополнение товарных запасов', ShoppingCart],
]

const Card = ({ offer }) => {
	const [title, Icon] = offer

	return (
		<div className={styles.helpBusinesses}>
			<div className={styles.hbIcon}>
				<Icon />
			</div>

			<h4 className={styles.hbTitle}>{title}</h4>
		</div>
	)
}

export const View = () => (
	<div className={styles.helpBusinessesWrapper}>
		<h2 className={styles.title}>
			С 2012 года
			<br />
			<span>помогаем бизнесу в любых ситуациях</span>
		</h2>
		{offers.map(([label, ...rest]) => (
			<Card key={label} offer={[...rest]} />
		))}
		<div className={styles.btnWrapper}>
			<Button size='l' className={styles.button} onClick={scrollToApplicationForm}>
				Рассчитать кредит
			</Button>
		</div>
	</div>
)
